/* __next_internal_client_entry_do_not_use__ ContactFormLink,ContactFormLinkFormatting auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button/Button";
import { trackCxFoundationsErrorboundaryClick } from "@faire/web-api--source/events/cxFoundations/click/errorboundary";
import support from "@faire/web-api--source/routes/support";
import isEmpty from "lodash/isEmpty";
import React from "react";
import { useStrictLocalization } from "../common/localization";
export var ContactFormLink = function(param) {
    var children = param.children, onClick = param.onClick, loggedOut = param.loggedOut, brandOrderToken = param.brandOrderToken;
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: support({
            contact: "true",
            loggedOut: loggedOut ? "true" : undefined,
            brand_order_token: brandOrderToken
        }),
        onClick: onClick,
        target: "_blank",
        rel: "noreferrer",
        tertiaryColor: "inherit",
        style: {
            font: "inherit"
        },
        children: !isEmpty(children) ? children : strictLocalize({
            id: "wwG3oY",
            defaultMessage: [
                {
                    type: 0,
                    value: "contact us"
                }
            ]
        })
    });
};
export var ContactFormLinkFormatting = function(chunk) {
    return /*#__PURE__*/ _jsx(ContactFormLink, {
        onClick: trackCxFoundationsErrorboundaryClick,
        children: chunk
    });
};
